import { createStore } from 'vuex'
import company from './modules/company'
import iconApp from '@/assets/img/iconapp.png';
import iconAppWhite from '@/assets/img/iconapp_white.png';
export default createStore({
  state: {
    user: null,
    empresa: null,
    token: localStorage.getItem('token') || null,
    isAuthenticated: !!localStorage.getItem('token'),
    app:{
      logo: iconApp,
      logo_white: iconAppWhite,
      version: '2.2.10',
      // para lso cambios de versión el primer numero indica el Anexo de núevos módulos.
      // El segundo indica cambio en diseño UX/UI
      // El tercero indica cambios en funcionalidades y reparacion de bugs 
    }
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user,
    empresa: (state) => state.empresa,
    app: (state) => state.app
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      state.isAuthenticated = true
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      // state.empresa = user
    },
    SET_EMPRESA(state, empresa) {
      state.empresa = empresa
      localStorage.setItem('company_data', JSON.stringify(empresa))
      // state.user = empresa
    },
    SET_APP(state,app){
      state.app = app
    },
    RESTORE_STATE(state) {
      // Restaurar token
      const token = localStorage.getItem('token')
      if (token) {
        state.token = token
        state.isAuthenticated = true
      }

      // Restaurar datos de usuario/empresa
      const userData = localStorage.getItem('company_data')
      // console.log("lo que contiene company_data:", userData)
      if (userData) {
        try {
          const parsedData = JSON.parse(userData)
          // state.user = parsedData
          state.empresa = parsedData
        } catch (error) {
          console.error('Error al parsear company_data:', error)
          localStorage.removeItem('company_data')
        }
      }
    },
    LOGOUT(state) {
      state.token = null
      state.user = null
      state.empresa = null
      state.isAuthenticated = false
      localStorage.removeItem('token')
      localStorage.removeItem('company_data')
    },
  },
  actions: {
    login({ commit }, { token, empresa }) {
      commit('SET_TOKEN', token)
      commit('SET_EMPRESA', empresa)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    restoreState({ commit }) {
      commit('RESTORE_STATE')
    },
    setApp({commit},app){
      commit('SET_APP',app)
    }
  },
  modules: {
    company,
  },
})